var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 156,
    viewBox: "0 0 346 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.49664,
    y: 33.7166,
    width: 33,
    height: 311,
    transform: "rotate(-69.5669 7.49664 33.7166)",
    fill: "#FFD770"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.896 117.42C316.038 114.664 313.333 112.441 309.981 111.192C301.442 108.011 291.94 112.355 288.759 120.894C285.577 129.433 289.921 138.935 298.46 142.116C301.812 143.365 305.312 143.454 308.52 142.585L339.361 139.746L317.896 117.42Z",
    fill: "#FFF3D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30.9236,
    width: 33,
    height: 23,
    rx: 4,
    transform: "rotate(-69.5669 0 30.9236)",
    fill: "#E79E9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.755 128.491C326.84 129.785 325.296 131.668 324.428 133.999C323.559 136.33 323.496 138.764 324.097 140.996L339.421 139.585L328.755 128.491Z",
    fill: "#1E120B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d3908949d80cfda1b7fc8d6824273c8e.svg";
export { ForwardRef as ReactComponent };